///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch } from "react-redux";

import HeaderCell from "../../../components/HeaderCell";
import messages from "../../../helpers/messages";
import { sortListView } from "../../../slices/activeBidsSlice";

const TableHeader = ({ isFetching, sortField, sortOrder }) => {
  const dispatch = useDispatch();
  const sortBids = ({ fieldName }) => dispatch(sortListView(fieldName));

  return (
    <thead data-testid="table-header">
      <tr className="header-row bg-white font-size-14">
        <HeaderCell
          label={messages.status.defaultMessage}
          minWidth="100px"
          isFetching={isFetching}
          fieldName="bidStatusId"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.uniqueBidName.defaultMessage}
          minWidth="135px"
          isFetching={isFetching}
          fieldName="bidName"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.accountName.defaultMessage}
          minWidth="135px"
          isFetching={isFetching}
          fieldName="shipperName"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.team.defaultMessage}
          minWidth="125px"
          isFetching={isFetching}
          fieldName="teamCount"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.pricingDueDateWithoutDate.defaultMessage}
          minWidth="115px"
          isFetching={isFetching}
          fieldName="deadlineDateUTC"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.rateEffectiveDate.defaultMessage}
          minWidth="115px"
          isFetching={isFetching}
          fieldName="startDateUTC"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.lane.defaultMessage}
          minWidth="73px"
          isFetching={isFetching}
          arrowLeft={true}
          fieldName="laneCount"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle text-right"
        />
        <HeaderCell
          label={messages.assignments.defaultMessage}
          minWidth="160px"
          isFetching={isFetching}
          fieldName="assignmentsCount"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
        <HeaderCell
          label={messages.time.defaultMessage}
          minWidth="72px"
          isFetching={isFetching}
          arrowLeft={true}
          fieldName="lastStatusChangeDateUTC"
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle text-right"
        />
        <HeaderCell
          label={messages.tags.defaultMessage}
          minWidth="190px"
          isFetching={isFetching}
          sortField={sortField}
          sortOrder={sortOrder}
          sortBids={sortBids}
          className="px-8 py-12 align-middle"
        />
      </tr>
    </thead>
  );
};

export default TableHeader;
